import React, { PureComponent } from 'react';
import { Table, Column, PopOver, OverlayTrigger } from '@tencent/spaui';
import { getTopCost } from '@/pages/agency/home/api';
import { currencyFormat } from '../../../utils/format';
import industry_cost_icon from './assets/industry_cost.svg';
import mdm_cost_icon from './assets/mdm_cost.svg';
import mdm_increase_icon from './assets/mdm_increase.svg';
import uid_cost_icon from './assets/uid_cost.svg';

import './index.scoped.less';

export enum TopListType {
  uid_cost = 'uid_cost',
  industry_cost = 'industry_cost',
  mdm_cost = 'mdm_cost',
  mdm_increase = 'mdm_increase',
}

interface ColumnData {
  dataIndex: string;
  name: string;
}

const COLUMN: ColumnData[] = [
  { dataIndex: 'name', name: '账户名称' },
  { dataIndex: 'total_cost', name: '消耗(元)' },
  { dataIndex: 'increase', name: '较上日涨幅(元)' },
  { dataIndex: 'day_to_day_comp', name: '日环比' },
  { dataIndex: 'week_to_week_comp', name: '周同比' },
];
const COLUMN2: ColumnData[] = [
  { dataIndex: 'name2', name: '客户名称' },
  { dataIndex: 'total_cost', name: '消耗(元)' },
  { dataIndex: 'increase', name: '较上日涨幅(元)' },
  { dataIndex: 'day_to_day_comp', name: '日环比' },
  { dataIndex: 'week_to_week_comp', name: '周同比' },
];
const COLUMN3: ColumnData[] = [
  { dataIndex: 'industry_name', name: '行业名称' },
  { dataIndex: 'total_cost', name: '消耗(元)' },
  { dataIndex: 'increase', name: '较上日涨幅(元)' },
  { dataIndex: 'day_to_day_comp', name: '日环比' },
  { dataIndex: 'week_to_week_comp', name: '周同比' },
];

const TOP_TYPE_MAP = {
  [TopListType.uid_cost]: 'TOP_TYPE_UID',
  [TopListType.industry_cost]: 'TOP_TYPE_INDUSTRY',
  [TopListType.mdm_cost]: 'TOP_TYPE_MDM',
  [TopListType.mdm_increase]: 'TOP_TYPE_MDM',
};

interface TopListProps {
  type: TopListType;
}

interface TopListState {
  tableLoading?: boolean;
  data_update_time?: string;
  items: Record<TopListType, {
    key: TopListType;
    title: string;
    data: any[];
    column: ColumnData[];
    permName?: string; // 作用？
    icon: any;
  }>;
}

class TopList extends PureComponent<TopListProps, TopListState> {
  constructor(props: TopListProps) {
    super(props);
    this.state = {
      items: {
        uid_cost: {
          key: TopListType.uid_cost,
          title: '账户(Top 5)',
          data: [],
          column: COLUMN,
          icon: uid_cost_icon,
        },
        industry_cost: {
          key: TopListType.industry_cost,
          title: '行业消耗(Top5)',
          data: [],
          column: COLUMN3,
          icon: industry_cost_icon,
        },
        mdm_cost: {
          key: TopListType.mdm_cost,
          title: '客户消耗(Top 5)',
          data: [],
          column: COLUMN2,
          icon: mdm_cost_icon,
        },
        mdm_increase: {
          key: TopListType.mdm_increase,
          title: '客户消耗增长(Top 5)',
          data: [],
          column: COLUMN2,
          icon: mdm_increase_icon,
        },
      },
    };
  }

  componentDidMount() {
    this.getTopCost();
  }

  getTopCost = async () => {
    const { type } = this.props;

    const { code, data } = await getTopCost({
      data: {
        top_type: TOP_TYPE_MAP[type] || '',
      },
    });

    if (code === 0) {
      this.setState((state) => ({
        items: {
          ...state.items,
          [type]: {
            ...state.items[type],
            data: data[type].map((x: any, i: number) => {
              x.index = i;
              x.name2 = x.name;
              return x;
            }),
          },
        },
        data_update_time: data.data_update_time,
      }));
    }
  };

  columnRender = (type: string, name: string, value: any, data: any, _checkedValue: any, _disabled: any, rowIndex: number) => {
    let result: JSX.Element | string = '';
    if (type !== 'head') {
      switch (name) {
        case 'name':
          result = (
            <OverlayTrigger trigger="hover" placement="top" overlay={<PopOver>{`${data.name}(${data.id})`}</PopOver>}>
              <div>
                <span className="nameli" style={{ overflow: 'initial' }}>
                  <span className={`order-num num-${rowIndex + 1} wbg`} style={{ float: 'left' }}>
                    {data.index + 1}
                  </span>
                  <p
                    style={{
                      display: 'inline-block',
                      width: 'calc(100% - 36px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      verticalAlign: 'bottom',
                    }}
                  >
                    <span>{data.name} </span>
                    <span>{data.id} </span>
                  </p>
                </span>
              </div>
            </OverlayTrigger>
          );
          break;
        case 'industry_name':
          result = (
            <OverlayTrigger trigger="hover" placement="top" overlay={<PopOver>{data.name}</PopOver>}>
              <div>
                <span className="nameli" style={{ overflow: 'initial' }}>
                  <span className={`order-num num-${rowIndex + 1} wbg`} style={{ float: 'left' }}>
                    {data.index + 1}
                  </span>
                  <p
                    style={{
                      display: 'inline-block',
                      width: 'calc(100% - 36px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      verticalAlign: 'bottom',
                    }}
                  >
                    <span>{data.name} </span>
                    {/* <span>{data.id} </span> */}
                  </p>
                </span>
              </div>
            </OverlayTrigger>
          );
          break;
        case 'name2':
          result = (
            <OverlayTrigger trigger="hover" placement="top" overlay={<PopOver>{data.name}</PopOver>}>
              <div>
                <span className="nameli">
                  <span className={`order-num num-${rowIndex + 1} wbg`}>{data.index + 1}</span>
                  <p
                    style={{
                      display: 'inline-block',
                      width: 'calc(100% - 36px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      verticalAlign: 'bottom',
                    }}
                  >
                    <span>{data.name} </span>
                  </p>
                </span>
              </div>
            </OverlayTrigger>
          );
          break;
        case 'total_cost':
          result = <span className="table_bold">{currencyFormat(value)}</span>;
          break;
        case 'day_to_day_comp':
        case 'week_to_week_comp':
          if (value == 0) {
            result = <span className="table_bold">{currencyFormat(value)}</span>;
          } else {
            result = <>
              {
                value != 0
                  ? <span className={value > 0 ? 'table_reduce' : 'table_increase'}>{value > 0 ? '+' : '-'}</span>
                  : null
              }
              <span className='table_bold'>{currencyFormat(value).replace('-', '')}%</span>
            </>;
          }
          break;
        case 'increase':
          if (value == 0) {
            result = <span className="table_bold">{currencyFormat(value)}</span>;
          } else {
            result = <>
              {
                value != 0
                  ? <span className={value > 0 ? 'table_reduce' : 'table_increase'}>{value > 0 ? '+' : '-'}</span>
                  : null
              }
              <span className='table_bold'>{currencyFormat(value).replace('-', '')}</span>
            </>;
          }
          break;
        default:
          result = value;
      }
    } else {
      result = value;
    }
    return result;
  };

  render() {
    const { tableLoading, data_update_time = '', items } = this.state;
    const { type } = this.props;
    const item = items[type] || {};

    return (
      <div>
        <div className="titlebar">
          <img style={{ marginRight: '8px' }} src={item.icon} />
          <h4 className="title">{item.title}</h4>
          <span className='right'>{data_update_time}</span>
        </div>
        <div className='content'>
          <Table data={item.data} key={item.permName} bordered={false} loading={tableLoading}>
            {item.column.map((x) => {
              return (
                <Column
                  key={x.dataIndex}
                  lign={x.dataIndex == 'name2' || x.dataIndex == 'name' || x.dataIndex == 'industry_name' ? 'left' : 'right'}
                  name={x.dataIndex}
                  render={this.columnRender}
                  fixedable
                >
                  {x.name}
                </Column>
              );
            })}
          </Table>
        </div>
      </div>
    );
  }
}

export default TopList;
